// import '../App.css';
import FullPageChat from "../components/FullPageMui";

function ChatPage(props) {
  return (
    <>
      <FullPageChat 
        logoLink="/"
        company_name="Mon plombier" 
        logoColor="#43527F" 
        TCM_API_KEY="tcmGnwutCElj2hTmKfVd53kkyiY6irJZfaQ6S3dbiv6ik3RHxvoBvYTQehuRzIlv"
        sendButtonColor="#fff00f" 
        fixedFooter={false}
        label="Ecrivez votre message ..."
      />
    </>

  );
}

export default ChatPage

